var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" MAIN - entry point - list things to do, how to find things, new notices dashboard cards - days till refresh credits - + equiv text, days till run out of credit + refresh. sms sent sms replies? invopice statistics (from xero - total open, total due, total overdue, count + $$) failed messages (number ... ) ")])
}
var staticRenderFns = []

export { render, staticRenderFns }